import { createContext, ReactNode, useMemo } from "react";

export type DialogContextValue = {
  title: string;
  onClose: () => void;
};

export const DialogContext = createContext<DialogContextValue | undefined>(undefined);

type DialogProviderProps = DialogContextValue & { children: ReactNode };

// Private: the context is exported for headers to read, but only Dialog provides it.
export function DialogProvider({ children, ...value }: DialogProviderProps) {
  const context = useMemo(
    () => value,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value.title, value.onClose]
  );
  return <DialogContext.Provider value={context}>{children}</DialogContext.Provider>;
}
